import React, { useState } from 'react';
import PlantBackground from '../components/PlantBackground';
import { FaLeaf, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaQuestionCircle, FaCommentDots, FaArrowRight, FaPaperPlane } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [careerForm, setCareerForm] = useState({ name: '', email: '', phone: '', Education: '', position: '', experience: '', coverLetter: '' });
  const [careerSubmitted, setCareerSubmitted] = useState(false);
  const [careerLoading, setCareerLoading] = useState(false);
  const [activeForm, setActiveForm] = useState('contact');

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => { setLoading(false); setSubmitted(true); }, 1800);
  };

  const handleCareerChange = e => setCareerForm({ ...careerForm, [e.target.name]: e.target.value });

  const handleCareerSubmit = e => {
    e.preventDefault();
    setCareerLoading(true);
    setTimeout(() => { setCareerLoading(false); setCareerSubmitted(true); }, 1800);
  };

  return (
    <div className="page-wrapper contact-page">
      {/* ════ CONTACT HERO — Split Botanical ════ */}
      <section className="contact-hero">
        <div className="contact-hero-leaf contact-hero-leaf--1"><FaLeaf /></div>
        <div className="contact-hero-leaf contact-hero-leaf--2"><FaLeaf /></div>
        <div className="contact-hero-leaf contact-hero-leaf--3"><FaLeaf /></div>


        <div className="contact-hero-inner">
          {/* LEFT: Text */}
          <div className="contact-hero-left" style={{ animation: 'fadeInLeft 0.8s ease both' }}>
            <div className="section-tag">Let's Grow Together</div>
            <h1 className="contact-hero-title">
              Say <span className="gold-text">Hello</span><br />
              to Your <em>Green Future</em>
            </h1>
            <p className="contact-hero-desc">
              Whether you want to buy plants, book a landscape designer, or explore partnership opportunities — we'd love to hear from you.
            </p>
            <div className="contact-hero-actions">
              <a href="#contact-form" className="btn-primary">
                <span>Get Free Consultation</span>
                <FaArrowRight />
              </a>
              <a href="tel:+919876543210" className="btn-outline"><FaPhoneAlt /> Call Us Now</a>
            </div>
          </div>

          {/* RIGHT: Image Banner */}
          <div className="contact-hero-right" style={{ animation: 'fadeInRight 0.8s 0.2s ease both' }}>
            <div className="contact-hero-image-wrapper">
              <img src="/images/Modern succulent.jpg" alt="Contact Banner" className="contact-hero-img" />
              <div className="contact-hero-img-backdrop"></div>
            </div>
          </div>
        </div>

        <div className="contact-hero-wave">
          <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
            <path d="M0,60 C360,0 1080,80 1440,20 L1440,80 L0,80 Z" fill="var(--bg-dark)" />
          </svg>
        </div>
      </section>

      {/* ════ CONTACT MAIN ════ */}
      <section className="contact-main">
        <div className="form-toggle">
          <button
            className={activeForm === 'contact' ? 'toggle-btn active' : 'toggle-btn'}
            onClick={() => setActiveForm('contact')}
          >
            Send Message
          </button>

          <button
            className={activeForm === 'career' ? 'toggle-btn active' : 'toggle-btn'}
            onClick={() => setActiveForm('career')}
          >
            Join Our Team
          </button>
        </div>
        <div className="forms-container">
          {/* Left: Contact Form */}
          {activeForm === 'contact' && (
            <div className="contact-form-wrap">
              {!careerSubmitted ? (
                <form className="contact-form" onSubmit={handleCareerSubmit} id="career-form">
                  <div className="form-header">
                    <h2 className="form-title">Send Us a <span className="gold-text">Message</span></h2>
                    <p className="form-subtitle">Fill in the details below and we'll get back to you shortly.</p>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">Your Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-input"
                        placeholder="Ram Sharma"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-input"
                        placeholder="ram@example.com"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label" htmlFor="phone">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-input"
                        placeholder="+91 98765 43210"
                        value={form.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="service">Service Interested In</label>
                      <select
                        id="service"
                        name="service"
                        className="form-input form-select"
                        value={form.service}
                        onChange={handleChange}
                      >
                        <option value="">Select a service...</option>
                        <option value="garden-design">Indoor Plants</option>
                        <option value="plant-supply">Outdoor Plants</option>
                        <option value="indoor-plants">Landscaping Services</option>
                        <option value="maintenance">Plant Rental Service</option>
                        <option value="landscaping">AMC Plant Maintenance</option>
                        <option value="consultation">Plant Library Program</option>
                        <option value="consultation">Training Programs</option>
                        <option value="consultation">Franchise Inquiry</option>
                        <option value="consultation">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="message">Your Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-input form-textarea"
                      placeholder="Tell us about your plant requirement, garden project, or service inquiry..."
                      rows={5}
                      value={form.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className={`form-submit ${loading ? 'loading' : ''}`}
                    id="submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner" />
                        Sending...
                      </>
                    ) : (
                      <>
                        <span>Send Message</span>
                        <FaPaperPlane />
                      </>
                    )}
                  </button>
                </form>
              ) : (
                <div className="form-success">
                  <div className="success-icon"><FaLeaf /></div>
                  <h2 className="success-title">Request Submitted Successfully!</h2>
                  <p className="success-desc">
                    Thank you for contacting Nisarg Plant Library & Nursery. Our team will connect with you shortly to assist with your requirements.
                  </p>
                  <button className="btn-primary" onClick={() => setSubmitted(false)} style={{ margin: '0 auto', display: 'flex' }}>
                    <span>Send Another Message</span>
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Right: Career Form */}
          {activeForm === 'career' && (
            <div className="contact-form-wrap">
              {!careerSubmitted ? (
                <form className="contact-form" onSubmit={handleCareerSubmit} id="career-form">
                  <div className="form-header">
                    <h2 className="form-title">Join Our <span className="gold-text">Green Team</span></h2>
                    <p className="form-subtitle">Grow your career with one of the region's trusted plant and landscaping teams.</p>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label" htmlFor="careerName">Your Name *</label>
                      <input type="text" id="careerName" name="name" className="form-input" placeholder="Ram Sharma" value={careerForm.name} onChange={handleCareerChange} required />
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="careerEmail">Email Address *</label>
                      <input type="email" id="careerEmail" name="email" className="form-input" placeholder="ram@example.com" value={careerForm.email} onChange={handleCareerChange} required />
                    </div>
                  </div>



                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label" htmlFor="contactNo">
                        Contact Number *
                      </label>
                      <input
                        type="tel"
                        id="contactNo"
                        name="contactNo"
                        className="form-input"
                        placeholder="+91 98765 43210"
                        value={careerForm.contactNo || ''}
                        onChange={handleCareerChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="education">
                        Education *
                      </label>
                      <input
                        type="text"
                        id="education"
                        name="education"
                        className="form-input"
                        placeholder="B.Sc. Agriculture"
                        value={careerForm.education || ''}
                        onChange={handleCareerChange}
                        required
                      />
                    </div>
                  </div>



                  <div className="form-group">
                    <label className="form-label" htmlFor="position">Position Interested In</label>
                    <select id="position" name="position" className="form-input form-select" value={careerForm.position} onChange={handleCareerChange}>
                      <option value="">Select a position...</option>
                      <option value="botanist">Plant Care Specialist</option>
                      <option value="designer">Landscape Designer</option>
                      <option value="sales">Sales & Customer Support</option>
                      <option value="internship">Nursery Executive</option>
                      <option value="internship">Plant Maintenance Executive</option>

                    </select>
                  </div>


                  <div className="form-group">
                    <label className="form-label" htmlFor="experience">
                      Experience *
                    </label>

                    <select
                      id="experience"
                      name="experience"
                      className="form-input form-select"
                      value={careerForm.experience}
                      onChange={handleCareerChange}
                      required
                    >
                      <option value="">Select Experience</option>
                      <option value="fresher">Fresher</option>
                      <option value="0-1">0 - 1 Year</option>
                      <option value="1-3">1 - 3 Years</option>
                      <option value="3-5">3 - 5 Years</option>
                      <option value="5-10">5 - 10 Years</option>
                      <option value="10+">10+ Years</option>
                    </select>
                  </div>




                  <div className="form-group">
                    <label className="form-label" htmlFor="coverLetter">Why join us? *</label>
                    <textarea id="coverLetter" name="coverLetter" className="form-input form-textarea" placeholder="Tell us about your experience, skills, and passion for plants..." rows={4} value={careerForm.coverLetter} onChange={handleCareerChange} required />
                  </div>

                  <button type="submit" className={`form-submit ${careerLoading ? 'loading' : ''}`} disabled={careerLoading}>
                    {careerLoading ? (
                      <><span className="spinner" />Sending...</>
                    ) : (
                      <><span>Submit Application</span><FaPaperPlane /></>
                    )}
                  </button>
                </form>
              ) : (
                <div className="form-success">
                  <div className="success-icon"><FaLeaf /></div>
                  <h2 className="success-title">Application Submitted!</h2>
                  <p className="success-desc">Thank you for your interest in joining Nisarg Plant Library & Nursery. Our team will review your application and contact you soon.</p>
                  <button className="btn-primary" onClick={() => setCareerSubmitted(false)} style={{ margin: '0 auto', display: 'flex' }}><span>Submit Another</span></button>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="info-container">
          <div className="info-header-center">
            <h2 className="contact-info-title">We're Always <span className="gold-text">Here To Help</span></h2>
          </div>

          <div className="info-cards-row">
            {[
              { icon: <FaMapMarkerAlt />, label: 'Visit Us', val: 'Nisarg Nursery', sub: ' A/P, Kasbe Digraj, Maharashtra 416305' },
              { icon: <FaPhoneAlt />, label: 'Call Us', val: '+91 9175025527  ', sub: 'Mon–Sat: 9AM – 7PM' },
              { icon: <FaEnvelope />, label: 'Email Us', val: 'hello@nisargnursery.in', sub: 'We reply within 24 hours' },
            ].map(({ icon, label, val, sub }) => (
              <div key={label} className="contact-info-card">
                <div className="info-card-icon">{icon}</div>
                <div>
                  <div className="info-card-label">{label}</div>
                  <div className="info-card-val">{val}</div>
                  <div className="info-card-sub">{sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════ FAQ SECTION ════ */}
      <section className="faq-section">
        <div className="section-container">
          <div className="section-header">
            <div className="section-tag">FAQ</div>
            <h2 className="section-title">Common <span className="gold-text">Questions</span></h2>
          </div>
          <div className="faq-grid">
            {[
              { q: 'Do you deliver plants across India?', a: 'Yes! We deliver pan-India with secure eco-friendly packaging. Delivery typically takes 3–5 business days.' },
              { q: 'What is your plant warranty policy?', a: 'All plants come with a 30-day health guarantee. If your plant doesn\'t survive, we\'ll replace it free of charge.' },
              { q: 'Do you offer free consultations?', a: 'Absolutely! We offer a free 30-minute consultation call or site visit for new clients planning garden projects.' },
              { q: 'How long does a garden design project take?', a: 'Depending on the scale, typically 2–8 weeks from design approval to project completion.' },
              { q: 'Can I visit your nursery?', a: 'Yes! Our nursery is open Mon–Sat 8AM–7PM and Sundays 10AM–3PM at FC Road, Pune.' },
              { q: 'Do you have corporate / bulk pricing?', a: 'Yes, we offer special packages for corporates, hotels, restaurants and bulk orders. Contact us for details.' },
            ].map(({ q, a }, i) => (
              <div key={i} className="faq-card">
                <div className="faq-q">{q}</div>
                <div className="faq-a">{a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};


export default Contact;
